import React, { useCallback } from "react";
import List from "@commonComponents/List";
import CustomOfficeForm from "@EUForms/customOffice/customOfficeForm";
import { useSelector } from "react-redux";
import { selectCustomOfficeTypeList, selectCustomOfficeList } from "@EUForms/selectors";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

const CustomOfficeDetail = ({ dataSource, ...rest }) => {

    const isOfficeTypeAleadyExist = useCallback((selectedOffice) => dataSource.some(c => c.type == selectedOffice), [dataSource])
    const customOfficeTypeList = useSelector(selectCustomOfficeTypeList)
    const officeNameList = useSelector(selectCustomOfficeList)
    const {isImportShipment} = useCurrentShipmentType()
    const renderItem = useCallback((item) => {
        const isTypeDisabled = isImportShipment ? ['DEC']?.includes(item?.type) : ['DEC', 'EXT']?.includes(item?.type)
        const isDeleteBtnDisabled = isImportShipment ? ['DEC']?.includes(item?.type) : ['DEC', 'EXT']?.includes(item?.type)
        return <CustomOfficeForm
            dataSource={item}
            key={item.id}
            isOfficeTypeAleadyExist={isOfficeTypeAleadyExist}
            customOfficeTypeList={customOfficeTypeList}
            officeNameList={officeNameList}
            isTypeDisabled={isTypeDisabled}
            isDeleteBtnDisabled={isDeleteBtnDisabled}
            {...rest} />
    }, [isOfficeTypeAleadyExist, customOfficeTypeList, officeNameList, rest])

    return <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem} />

}

export default React.memo(CustomOfficeDetail)
